module.exports = __webpack_public_path__ + "img/NL7802.d40ae937.png";